<template>
  <div class="filter-box" :class="{ open: filterClass }">
    <div class="filter-box-handle" @click="filterClass = !filterClass">
      <strong>Регионы({{ total }})</strong>
      <img src="~/assets/img/svg/Arrow-Down.svg" alt="#" />
    </div>
    <div v-if="isMore" class="filter-box-body">
      <div class="search_area">
        <input
          type="search"
          v-model="search"
          @keyup.prevent="onSearch"
          @input="onSearch"
        />
      </div>
      <span class="fw-bold is_header mb-2">Выбранные регионы</span>
      <div
        class="check-block-list with_scroll mt-2"
        :class="{ 'all-visible': isMore }"
      >
        <VacanciesCheckbox
          class="check-block"
          v-for="item in selectedItems"
          :checked="true"
          :class="{ is_header: item.is_header }"
          @change="toggleRegion(item.value)"
          :name="`selected_region_${item.value}`"
          :key="`selected_region_${item.value}`"
          :label="item.name"
        />
      </div>
      <div
        class="check-block-list with_scroll mt-3"
        :class="{ 'all-visible': isMore }"
      >
        <VacanciesCheckbox
          class="check-block"
          v-for="item in groupedFilterItems"
          :checked="item.is_checked"
          :class="{ is_header: item.is_header }"
          @change="toggleRegion(item.value)"
          :name="`unselected_region_${item.value}`"
          :label="item.name"
          :is_header="item.is_header"
          :key="`unselected_region_${item.value}`"
        />
      </div>
      <button
        class="more-filters"
        data-default-text="Еще 25"
        data-hide-text="Скрыть"
        @click="toggleMore"
      >
        Скрыть
      </button>
    </div>
    <div v-else class="filter-box-body">
      <div class="check-block-list" v-if="selectedItems.length">
        <VacanciesCheckbox
          class="check-block"
          v-for="item in selectedItems"
          :checked="true"
          @change="toggleRegion(item.value)"
          :name="`selected_region_${item.value}`"
          :label="item.name"
          :key="`selected_region_${item.value}`"
        />
      </div>
      <div
        v-else
        class="check-block-list with_scroll"
        :class="{ 'all-visible': isMore }"
      >
        <VacanciesCheckbox
          class="check-block"
          v-for="item in firstXSelectedItems"
          :checked="false"
          @change="toggleRegion(item.value)"
          :name="`region_${item.value}`"
          :label="item.name"
          :key="`region_${item.value}`"
        />
      </div>
      <button
        class="more-filters"
        :data-default-text="`Еще ${total}`"
        data-hide-text="Показать"
        @click="toggleMore"
        v-if="total > 0"
      >
        Еще {{ total }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import useSort from "~/composables/useSort";
import { useVacancyStore } from "~/store/vacancy";
import useQueryParams from "~/composables/useQueryParams.js";

const emit = defineEmits(["onFormChange"]);
const props = defineProps(["name", "isOpen", "selectedCountry"]);

const { updateQueryParam, getQueryParam } = useQueryParams();
const countries = ref(getQueryParam("countries") ?? [1]);
const vacancyStore = useVacancyStore();
const regions = ref(getQueryParam("regions") ?? []);
const search = ref("");

const total = computed(() =>
  vacancyStore.regions.length > 5 ? vacancyStore.regions.length - 5 : 0,
);

const filterClass = ref(true);
const isMore = ref(false);
const groupedFilterItems = ref([]);
const selectedItems = computed(() =>
  vacancyStore.regions_formatted.filter(({ value }) => {
    return regions.value?.includes(value);
  }),
);
const firstXSelectedItems = computed(() =>
  vacancyStore.regions_formatted.slice(0, 5),
);

watch(
  () => getQueryParam("countries") ?? [1],
  async (newValues, oldValues) => {
    if (JSON.stringify(newValues) !== JSON.stringify(oldValues)) {
      countries.value = newValues;
      await getRegions({ country_ids: countries.value });
      prepare(vacancyStore.regions_formatted);
    }
  },
);

watch(
  () => getQueryParam("regions") ?? [],
  (newValues, oldValues) => {
    if (JSON.stringify(newValues) !== JSON.stringify(oldValues)) {
      regions.value = newValues;
      prepare(vacancyStore.regions_formatted);
    }
  },
);

const toggleMore = () => (isMore.value = !isMore.value);

const onSearch = (e) => {
  const searchValue = e.target.value;
  const items = searchValue
    ? vacancyStore.regions_formatted.filter((item) =>
        item.name.toLowerCase().includes(searchValue.toLowerCase()),
      )
    : vacancyStore.regions_formatted;

  groupedFilterItems.value = items;
  prepare(items);
};

const toggleRegion = (id) => {
  let selected_ids = [...regions.value];

  if (!selected_ids.includes(id)) {
    selected_ids.push(id);
  } else {
    selected_ids = selected_ids.filter((item) => item !== id);
  }

  updateQueryParam("regions", selected_ids.length ? selected_ids : undefined);
};

const { sort } = useSort();
const prepare = (items) => {
  if (!items.length) {
    groupedFilterItems.value = [];
    return;
  }

  const selected_ids = [...regions.value];
  // selectedItems.value = items.filter((item) =>
  //   selected_ids.includes(item.value),
  // );

  let filterItems = items.filter((item) => !selected_ids.includes(item.value));
  filterItems = sort(filterItems, { by: "alpha" });

  groupedFilterItems.value = [];
  filterItems.forEach((item, index) => {
    const firstLetter = item.name.charAt(0);
    if (index === 0 || firstLetter !== filterItems[index - 1].name.charAt(0)) {
      groupedFilterItems.value.push({
        value: firstLetter,
        name: firstLetter,
        is_header: true,
      });
    }
    groupedFilterItems.value.push({
      value: item.value,
      name: item.name,
      is_header: false,
    });
  });
};

const { getRegions } = vacancyStore;
watch(() => vacancyStore.regions_formatted, prepare);

useAsyncData(
  "regions",
  async () => await getRegions({ country_ids: getQueryParam("countries") }),
);
</script>

<style scoped>
.check-block label {
  white-space: pre-wrap;
}

.with_scroll {
  max-height: 300px;
  overflow: auto;
}

.is_header .l-wrap label {
  font-weight: bold;
}

.is_header input,
.is_header .radio-mask {
  display: none;
}

input[type="search"] {
  width: 100%;
  margin-bottom: 1rem;
  border: 1px solid #cbcbcb;
  padding: 0.1rem 0.3rem;
}
</style>
